// extracted by mini-css-extract-plugin
export default {"agreement":"sOuQhdZsxVdKwgsS8WJU"};